/* eslint-disable no-loop-func */
import { ButtonPrimary } from "@components";
import { useEffect, useState, ChangeEvent } from "react";
import Timer from "../../stores/TimerModalStore";
import { FormInput } from "../Forms/Forms.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import ArrowDown from '../../assets/arrowDown.svg';
import deviceInfo from "../../utils/deviceInfo";


import {
  ComplaintContainer,
  ComplaintForm,
  InputsContainer,
  Label,
} from "./Complaint.styled";
import complaintAndLinkStore, {
  RegisterComplaintRequest,
} from "../../stores/ComplaintAndLinkStore";
import accountsNotificationsStore from "../../stores/AccountsNotificationsStore";
import User from "../../stores/UserStore";
import { observer } from "mobx-react-lite";
import { action, toJS } from "mobx";
import generalStore from "../../stores/GeneralStore";
import upload from "../../assets/upload.svg";
import General from "../../stores/GeneralStore";
import { useNavigate } from "react-router-dom";
import { NotifyError } from "../../../src/utils/ShowError";
import { ToastContainer } from "react-toastify";
import { NotifySuccess } from "../../utils/ShowSuccess";
import thanks from "../../assets/thanks.svg";
import HappyMeterStore from "../../stores/HappyMeter";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { style } from "@mui/system";
import { height } from "@mui/system";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";

// import { TabContainer, ThankyouHeader, ThankyouMessage } from "./Social.styled";
import {
  TabContainer,
  ThankyouHeader,
  ThankyouMessage,
} from "../../components/SocialCaseTbas/Social.styled";
import constants from "../../utils/constants";
import ReCAPTCHA from "react-google-recaptcha";

interface FileUpload {
  mediaType: string;
  fileName: string;
  buffer: string;
}


const key: string = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

const Complaint = observer(() => {
  const [selectedComplaintType, setSelectedComplainType] = useState<string>("");
  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState<boolean>(false);
  const [selectedFeedbackType, setSelectedFeedbackType] = useState<any[]>([]);
  const [categoryList, setCategoryList] = useState<any[]>([]);
  const [natureComplaitList, setnatureComplaitList] = useState<any[]>([]);
  const [complaintType, setcomplaintType] = useState<any>();
  const [feedback, setFeedback] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [selectedAccountNumber, setSelectedAccountNumber] =
    useState<string>("");
  const [deviceData, setDeviceData] = useState<any>(null);
  const[defaultPersonId,setDefaultPersonId]=useState<string>("")
  const [captchatoken, setCaptchatoken] = useState<string>("");

  const complainTypesOptions = [
    {
      key: "GEN-COMPL",
      value: "Complaint Case for General Complaint",
    },
  ] as const;
  const searchParams: any = new URLSearchParams(window.location.search)
  const stateParam = searchParams.get('state');
  const stateParamLan = searchParams.get('Lang');
  const handleRecaptchaChange = (token: any) => {
    setCaptchatoken(token);
    // console.log("ReCAPTCHA token:", token);
    setIsRecaptchaVerified(true);
  };
  useEffect(() => {
    if (stateParamLan) {
      defaultLanguage(stateParamLan)
    }
  }, []);
   useEffect(() => {
      const fetchDeviceInfo = async () => {
        const data = await deviceInfo();
        setDeviceData(data);
      };
      fetchDeviceInfo();
    }, []);
  const defaultLanguage = async (data: any) => {
    localStorage.setItem("settingUplanguage", data);
    await General.getCodeLabels();
  }
  const handleUploadFileChange = async (
    event: ChangeEvent<HTMLInputElement>,
    setFieldValue: Function
  ) => {
    const files: FileList | null = event.target.files;
    const fileUploadPromises: Promise<FileUpload>[] = [];

    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file: File = files[i];
        const maxSize = 10 * 1024 * 1024; // 10 MB in bytes
        if (file.size > maxSize) {
          const errorMessage = General?.codeLabels["cm_file_upload_er"]?.label ? General?.codeLabels["cm_file_upload_er"]?.label : "Please upload file that have less than 10 MB";
          NotifyError(errorMessage);
          return;
        }
        // Check if the file is a PDF
        if (constants?.allowedFileTypes?.includes(file.type)) {
          const promise = new Promise<FileUpload>((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(file);
            reader.onload = () => {
              const buffer = reader.result?.slice(28) as string;
              const fileName = file.name;
              const mediaType = file.type;

              const fileUpload: FileUpload = { mediaType, fileName, buffer };
              resolve(fileUpload);
            };
          });

          fileUploadPromises.push(promise);
        } else {
          const errorMessage = "Invalid file type. Please select a PNG, JPG, JPEG, or PDF file.";
          NotifyError(errorMessage);
        }
      }

      Promise.all(fileUploadPromises)
        .then((uploadedFiles) => {
          setFieldValue("uploadedFilesData", uploadedFiles); // Update Formik field value
        })
        .catch((error) => {
          console.error("Error while processing file uploads:", error);
        });
    }
  };

  const handleSelectComplaintTypeChange = (
    event: ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedComplainType(event.target.value);
  };
  const handleSelectFeedbackTypeChange = (
    event: ChangeEvent<HTMLSelectElement>
  ) => {
    setFeedback(event.target.value);
  };
  const handleSelectCategoryTypeChange = (
    event: ChangeEvent<HTMLSelectElement>
  ) => {
    setCategory(event.target.value);
  };

  const handleSelectAccountNumberChange = (
    event: ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedAccountNumber(event.target.value);
  };
  const [submitLoader, setSubmitLoader] = useState(false);
  const [thanku, setThanku] = useState(false);
  const [seccessMsg, setSuccessMsg] = useState<any>("");
  const [referenceId, setReferenceId] = useState<any>("");
  const handleSubmit = async (
    values: any,
    { resetForm, setFieldError, errors }: any
  ) => {
    setSubmitLoader(true);


    if (isRecaptchaVerified) {


      const itemType = categoryList?.find((item) => item?.code == category);
      const subCategoryType = selectedFeedbackType?.find(
        (item) => item?.code == feedback
      );
      const categoryType = complaintAndLinkStore.complaintTypes?.find(
        (item) => item?.code == selectedComplaintType
      );
      let data = JSON.stringify({
        data: {
          complaintType: selectedComplaintType,
          // complaintType: "GEN-COMPL",
          accountID: User.info.personId ? selectedAccountNumber : values?.sewerageNumber,
          comment: values.complaintDetails,
          email: User?.profile?.personId ? User?.profile?.email : values?.email,
          name: User?.profile?.personId ? User?.profile?.name?.split(" ")[0] : values?.name,
          // name:User?.profile?.name,
          mobileNumber: User?.profile?.personId ? User?.profile?.mobile : values?.phoneNumber,
          personId: User?.profile?.personId ? User.info.personId : defaultPersonId,
          platform: "Web",
          category: {
            //category complainttype
            code: selectedComplaintType,
            type: categoryType?.ccbCharacteristicType,
          },
          subCategory: {
            //feedback gainst
            code: feedback,
            type: subCategoryType?.ccbCharacteristicType,
          },
          item: {
            //category
            code: category,
            type: itemType?.ccbCharacteristicType,
          },
          recaptchaToken:captchatoken,
          dataConsent: User?.profile?.personId ? null : {
            deviceVersion: deviceData.device,
            location: deviceData.ip,
            browser: deviceData.platform,
            personId: User.profile.personId || defaultPersonId,
            fullName: User.profile.name || values?.name,
            email: User.profile.email || values?.email,
            contactNo: User.profile.mobileNumber || values?.phoneNumber,
            referenceId: "",
            modeOfConsent: "Feedback",
          },
        },
        
        multiFileUpload: values.uploadedFilesData,
        // multiFileUpload: [],
        isFileTypeValid: true,
        isFileUploadValid: true,
        // invalidFileNames: [
        // "string"
        // ]
      });

      const res = await complaintAndLinkStore.submitComplaint({
        errorId: "submitComplaintError",
        data,
      });

      // if (res?.data?.message === "Success") {
      //   resetForm();
      //   setSubmitLoader(false);
      // }
      if (res?.data?.result?.status == "S") {
        resetForm();
        setSubmitLoader(false);
        const message = General?.codeLabels[res?.data?.result?.message]?.label;
        const refId = res?.data?.result?.caseId;
        setReferenceId(refId);
        const updatedMessage = message.replace("{0}", refId);
        setSuccessMsg(updatedMessage);
        setThanku(true);
        HappyMeterStore.openHappinessMeter();
        HappyMeterStore.setUPserviceID("11");
      } else {
        setSubmitLoader(false);
      }
    } else {
      NotifyError(General?.codeLabels["cm_recaptchaerror"]?.label)
    }
  };

  useEffect(() => {
    if(User?.info?.personId){
       User?.getServesis();
    const serviceId = User?.servesis?.find((element: any) => element?.serviceGuidePageLink?.toLowerCase() === "complaint")?.serviceGuideId;
    if (serviceId) {
     generalStore.incrementServiceUsage(serviceId);
    } ;

    }
   
    const asyncUseEffect = async () => {
      if (User.info.personId) {
        await accountsNotificationsStore.getMyAccounts({
          errorId: "getMyAccountsError",
          data: User.info.personId as string,
        });
        // setSelectedAccountNumber(
        //   accountsNotificationsStore.accounts[0].accountNumber ?? ""
        // );
      }

      await complaintAndLinkStore.getComplaintTypes({
        errorId: "getComplaintTypesError",
      });
      setnatureComplaitList(complaintAndLinkStore.complaintTypes)
      setcomplaintType(stateParam);
      setSelectedComplainType(
        complaintAndLinkStore.complaintTypes[0].value ?? ""
      );
    };
    asyncUseEffect();
  }, []);
  useEffect(() => {
    const asyncUseEffect = async () => {
      const res = await complaintAndLinkStore.feedback({
        errorId: "getComplaintTypesError",
        data: selectedComplaintType,
      });
      if (res.defaultPersonId)
      {

        setDefaultPersonId(res.defaultPersonId);
      }
      setSelectedFeedbackType(res);
    };
    asyncUseEffect();
  }, [selectedComplaintType]);
  useEffect(() => {
    const asyncUseEffect = async () => {
      const data = { code: selectedComplaintType, subcode: feedback };
      const res = await complaintAndLinkStore.category({
        errorId: "getComplaintTypesError",
        data,
        // subcode:feedback
      });
      setCategoryList(res);
    };
    asyncUseEffect();
  }, [feedback]);

  const navigate = useNavigate();
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  var initialValueFormik;
  var validationSchemaFormik;
  if (!User?.profile?.personId) {
    initialValueFormik = {
      // inputPremiseUsage: "",
      complaintDetails: "",
      name: "",
      email: "",
      phoneNumber: "",
      sewerageNumber: "",
      uploadedFilesData: [],
      complaintType: "",
      feedbackAgainst: "",
      category: "",
      toggle: false,
    }
    validationSchemaFormik = Yup.object().shape({
      complaintDetails: Yup.string().required(General?.codeLabels['cm_complaint_er']?.label ? General?.codeLabels['cm_complaint_er']?.label : "Complaint Details are required").min(5, General?.codeLabels['cm_mob_detailmin']?.label).max(254, General?.codeLabels['cm_mob_detailmax']?.label),
      email: Yup.string().email('Invalid email address').required('Email is required'),
      phoneNumber: Yup.string()
        .required(General?.codeLabels["cm_mob_mobnumerr"]?.label)
        .matches(/^05[0-9]{8}$/, "Invalid mobile number"),
      name: Yup.string().matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_invalid_name"]?.label ? General?.codeLabels["cm_invalid_name"]?.label : "Invalid Name").required('Name is required'),
      //sewerageNumber: Yup.string().required(General?.codeLabels['cm_noc_noacct']?.label ? General?.codeLabels['cm_noc_noacct']?.label : "Account Number is Required Field "),
      complaintType: Yup.string().required(General?.codeLabels['cm_itemreqerr']?.label),
      feedbackAgainst: Yup.string().required(General?.codeLabels['cm_subcategoryreqerr']?.label),
      category: Yup.string().required(General?.codeLabels['cm_categoryreqerr']?.label),
    });
  } else {
    initialValueFormik = {
      // inputPremiseUsage: "",
      complaintDetails: "",
      complaintType: "",
      feedbackAgainst: "",
      category: "",
      sewerageNumber: "",
      uploadedFilesData: [], // Add this line
    }
    validationSchemaFormik = Yup.object().shape({
      complaintDetails: Yup.string().required(General?.codeLabels['cm_complaint_er']?.label ? General?.codeLabels['cm_complaint_er']?.label : "Complaint Details are required").min(5, General?.codeLabels['cm_mob_detailmin']?.label).max(254, General?.codeLabels['cm_mob_detailmax']?.label),
      complaintType: Yup.string().required(General?.codeLabels['cm_itemreqerr']?.label),
      feedbackAgainst: Yup.string().required(General?.codeLabels['cm_subcategoryreqerr']?.label),
      category: Yup.string().required(General?.codeLabels['cm_categoryreqerr']?.label),
      // sewerageNumber: Yup.string().required(General?.codeLabels['cm_noc_noacct']?.label ? General?.codeLabels['cm_noc_noacct']?.label : "Account Number is Required Field "),
      // uploadedFilesData: Yup.array()
      //   .min(1, "At least one file is required")
      //   .max(10, "Maximum of 10 files allowed"),
    });
  }

  return (
    <>
      {/* <ToastContainer/> */}
      <MoveInHeader
        style={{
          background: contrast?.contrastBackground ? contrast?.contrastBackground : "#62aa51",
          color: contrast?.contrastColor ? contrast?.contrastColor : "",
        }}
      >
        <div>
          <MiniNav>
            <ButtonSecondary
              style={{
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "transparent",
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                width: "81px",
                height: "30px",
                border: "1px solid #FFF",
              }}
              onClick={() =>
                navigate("/dashboard", { state: { fromRefund: true } })
              }
            >
              {General?.codeLabels["cm_back"]?.label ? General?.codeLabels["cm_back"]?.label : 'Back'}
            </ButtonSecondary>
            {User?.info?.personId && <ButtonSecondary
              style={{
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "transparent",
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                width: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "12rem" : "117px",
                height: "30px",
                border: "1px solid #FFF",
              }}
              onClick={() => navigate("/dashboard")}
            >
              {General?.codeLabels["cm_dashboard"]?.label !== undefined
                ? General?.codeLabels["cm_dashboard"]?.label
                : "DASHBOARD"}
            </ButtonSecondary>}
          </MiniNav>
          <h1
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: General?.isLargeScreen ? `${3.1 * General.accessibility.fontSize}rem` : `${2 * General.accessibility.fontSize}rem`,
              margin: "0",
              color: contrast?.contrastColor ? contrast?.contrastColor : "white",
            }}
          >
            {General?.codeLabels["cm_log_complaint"]?.label ? General?.codeLabels["cm_log_complaint"]?.label : 'Log a Complaint'}
          </h1>
        </div>
      </MoveInHeader>
      {!thanku ? (
        <Formik
          initialValues={initialValueFormik}
          validationSchema={validationSchemaFormik}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange, setFieldValue, errors, touched }) => (
            <Form >

              <ComplaintContainer
                style={{
                  background: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                  width: General?.isLargeScreen ? "" : "100%"
                }}
              >
                <ComplaintForm style={{ width: General?.isLargeScreen ? '' : '90%' }}>
                  <p
                    style={{
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "400",
                      fontSize: "16px",
                      lineHeight: "20px",
                      marginBottom: General?.isLargeScreen ? "2 0px" : "",
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : General?.ColorAss,
                      direction: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "ARA" ? "rtl" : "ltr"
                    }}
                    dangerouslySetInnerHTML={{ __html: General?.codeLabels["cm_feedback_intro"]?.label }}
                  >
                    {/* {General?.codeLabels["cm_complaint_info"]?.label ? General?.codeLabels["cm_complaint_info"]?.label : 'Please fill in the form below to submit your complaint. We will attend to it shortly.'} */}
                  </p>
                  <InputsContainer style={{ flexDirection: General?.isLargeScreen ? "row" : "column" }}>
                    <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : General?.ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "16px",
                        gap: "0.5rem",
                        height: "100px",
                        width: General?.isLargeScreen ? "45%" : "100%",
                      }}
                    >
                      {General?.codeLabels["cm_feedback_nact"]?.label !==
                        undefined
                        ? General?.codeLabels["cm_feedback_nact"]?.label
                        : "Complaint Type"}
                      *
                      <Field
                        as='select'
                        value={selectedComplaintType}
                        onChange={(e: any) => {
                          handleChange(e);
                          handleSelectComplaintTypeChange(e);
                        }}
                        style={{
                          background: `${contrast?.contrastColor ? contrast.contrastColor : "#edf4f6"}`,

                        }}
                        name='complaintType'
                      >
                        <option>
                          {General?.codeLabels["cm_selectitem"]?.label
                            ? General?.codeLabels["cm_selectitem"]?.label
                            : "Please select an item"}
                        </option>
                        {natureComplaitList?.map((type: any) => {

                          return (
                            <option selected={type.description == complaintType ? true : false} value={type.code} key={type.code}>
                              {type.description}
                            </option>
                          )
                        })}
                      </Field>
                      {/* <ErrorMessage
                        name="complaintType"
                        component="div"
                        className="error-message"
                      /> */}
                      {touched.complaintType && errors.complaintType && (
                        <div style={{ color: "red" }}>{errors.complaintType}</div>
                      )}
                    </Label>
                    <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : General?.ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "16px",
                        gap: "0.5rem",
                        height: "100px",
                        width: General?.isLargeScreen ? "45%" : "100%",
                      }}
                    >
                      {General?.codeLabels["cm_feedback_agst"]?.label !==
                        undefined
                        ? General?.codeLabels["cm_feedback_agst"]?.label
                        : "FeedBack Against"}
                      *
                      <Field
                        as='select'
                        name='feedbackAgainst'
                        // value={selectedComplaintType}
                        style={{
                          background: `${contrast?.contrastColor ? contrast.contrastColor : "#edf4f6"}`,

                        }}
                        onChange={(e: any) => {
                          handleChange(e);
                          handleSelectFeedbackTypeChange(e);
                        }}
                      >
                        <option selected>
                          {General?.codeLabels["cm_selectitem"]?.label
                            ? General?.codeLabels["cm_selectitem"]?.label
                            : "Please select an item"}
                        </option>
                        {selectedFeedbackType?.length > 0
                          ? selectedFeedbackType?.map((type: any) => (
                            <option value={type.code} key={type.code}>
                              {type.description}
                            </option>
                          ))
                          : null}
                      </Field>
                      <ErrorMessage
                        name="feedbackAgainst"
                        component="div"
                        className="error-message"
                      />
                    </Label>
                  </InputsContainer>
                  <InputsContainer style={{ flexDirection: General?.isLargeScreen ? "row" : "column" }}>
                    <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : General?.ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "16px",
                        gap: "0.5rem",
                        height: "100px",
                        width: General?.isLargeScreen ? "45%" : "100%",
                      }}
                    >
                      {General?.codeLabels["cm_category"]?.label !== undefined
                        ? General?.codeLabels["cm_category"]?.label
                        : "Category"}
                      *
                      <Field
                        as='select'
                        name='category'
                        // value={selectedComplaintType}
                        style={{
                          background: `${contrast?.contrastColor ? contrast.contrastColor : "#edf4f6"}`,

                        }}
                        onChange={(e: any) => {
                          handleChange(e);
                          handleSelectCategoryTypeChange(e);
                        }}
                      >
                        <option selected>
                          {General?.codeLabels["cm_selectitem"]?.label
                            ? General?.codeLabels["cm_selectitem"]?.label
                            : "Please select an item"}
                        </option>
                        {categoryList?.length > 0
                          ? categoryList?.map((type: any) => (
                            <option value={type.code} key={type.code}>
                              {type.description}
                            </option>
                          ))
                          : null}
                      </Field>
                      <ErrorMessage
                        name="category"
                        component="div"
                        className="error-message"
                      />
                    </Label>
                    {User.info.personId ? <Label
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : General?.ColorAss,
                        fontFamily: "Segoe UI",
                        fontStyle: "normal",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "16px",
                        gap: "0.5rem",
                        height: "100px",
                        width: General?.isLargeScreen ? "45%" : "100%",
                      }}
                    >
                      {General?.codeLabels["cm_daccountid"]?.label}*
                      <Field
                        as='select'
                        name='sewerageNumber'
                        value={selectedAccountNumber}
                        style={{
                          background: `${contrast?.contrastColor ? contrast.contrastColor : "#edf4f6"}`,
                          color: `${contrast?.contrastBackground ? contrast.contrastBackground : General?.ColorAss}`,
                        }}
                        onChange={(e: any) => {
                          handleChange(e);
                          handleSelectAccountNumberChange(e);
                        }}
                      >
                        <option value='' selected={true}>
                          {General?.codeLabels["cm_pdc_select"]?.label
                            ? General?.codeLabels["cm_pdc_select"]?.label
                            : "Please select an item"}
                        </option>
                        {accountsNotificationsStore.accounts.map((account) => (
                          <option
                            value={account?.accountNumber ?? ""}
                            key={account?.accountNumber}
                          >
                            {account.accountNumber}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="sewerageNumber"
                        component="div"
                        className="error-message"
                      />
                    </Label> :
                      <Label
                        style={{
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : General?.ColorAss,
                          fontFamily: "Segoe UI",
                          fontStyle: "normal",
                          fontWeight: "700",
                          fontSize: "16px",
                          lineHeight: "16px",
                          gap: "0.5rem",
                          height: "80px",
                          width: General?.isLargeScreen ? "45%" : "100%",
                        }}
                      >
                        {General?.codeLabels["cm_accountid"]?.label}
                        <Field
                          type="text"
                          name="sewerageNumber"
                          value={values.sewerageNumber}
                          onChange={handleChange}
                          className={errors.sewerageNumber && touched.sewerageNumber ? "error" : ""}
                          style={{
                            height: "300px",
                          }}
                        />
                        <ErrorMessage
                          name="sewerageNumber"
                          component="div"
                          className="error-message"
                        />
                      </Label>}

                  </InputsContainer>
                  {/* logout */}
                  {
                    !User?.profile?.personId && <>
                      <InputsContainer style={{ flexDirection: General?.isLargeScreen ? "row" : "column" }}>
                        <Label
                          style={{
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : General?.ColorAss,
                            width: General?.isLargeScreen ? "45%" : "100%",
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: "16px",
                            lineHeight: "16px",
                            gap: "0.5rem",
                            height: "80px",
                          }}
                        >
                          {General?.codeLabels["cm_customernamelabel"]?.label !== undefined
                            ? General?.codeLabels["cm_customernamelabel"]?.label
                            : "Name"}
                          *
                          <Field
                            type="text"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            className={errors.name && touched.name ? "error" : ""}
                            style={{
                              height: "300px",
                            }}
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="error-message"
                          />
                        </Label>
                        <Label
                          style={{
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : General?.ColorAss,
                            width: General?.isLargeScreen ? "45%" : "100%",
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: "16px",
                            lineHeight: "16px",
                            gap: "0.5rem",
                            height: "80px",
                          }}
                        >
                          {General?.codeLabels["cm_email"]?.label !== undefined
                            ? General?.codeLabels["cm_email"]?.label
                            : "Email"}

                          <Field
                            type="email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            className={errors.email && touched.email ? "error" : ""}
                            style={{
                              height: "300px",
                            }}
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="error-message"
                          />
                        </Label>
                      </InputsContainer>
                      <InputsContainer style={{ flexDirection: General?.isLargeScreen ? "row" : "column" }}>
                        <Label
                          style={{
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : General?.ColorAss,
                            width: General?.isLargeScreen ? "45%" : "100%",
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: "16px",
                            lineHeight: "16px",
                            gap: "0.5rem",
                            height: "80px",
                          }}
                        >
                          {General?.codeLabels["cm_mobilenumber"]?.label !==
                            undefined
                            ? General?.codeLabels["cm_mobilenumber"]?.label
                            : "Mobile Number*(05X-Xxx-Xxxx)"}

                          <Field
                            type="tel"
                            name="phoneNumber"
                            value={values.phoneNumber}
                            onChange={handleChange}
                            className={
                              errors.phoneNumber && touched.phoneNumber ? "error" : ""
                            }
                            style={{
                              height: "300px",
                            }}
                          />
                          <ErrorMessage
                            name="phoneNumber"
                            component="div"
                            className="error-message"
                          />
                        </Label>
                      </InputsContainer>
                    </>
                  }
                  <Label
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : General?.ColorAss,
                      width: "100%",
                      fontFamily: "Segoe UI",
                      fontStyle: "normal",
                      fontWeight: "700",
                      fontSize: "16px",
                      lineHeight: "16px",
                      gap: "0.5rem",
                      height: "100px",

                    }}
                  >
                    {General?.codeLabels["cm_comment"]?.label !== undefined
                      ? General?.codeLabels["cm_comment"]?.label
                      : " Complaint Details"}
                    *
                    <Field
                      as="textarea"
                      name="complaintDetails"
                      value={values.complaintDetails}
                      onChange={handleChange}
                      className={
                        errors.complaintDetails && touched.complaintDetails
                          ? "error"
                          : ""
                      }
                      style={{
                        height: "300px",
                        color: contrast?.contrastBackground ? contrast.contrastBackground : General?.ColorAss,
                        background: `${contrast?.contrastColor ? contrast.contrastColor : "#edf4f6"}`,
                      }}
                    />
                    <ErrorMessage
                      name="complaintDetails"
                      component="div"
                      className="error-message"
                    />
                  </Label>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      margin: "auto",
                      justifyContent: General?.isLargeScreen ? "space-between" : "flex-start",
                      height: General?.isLargeScreen ? "100px" : "150px",
                    }}
                  >
                    <div
                      style={{
                        width: "100vw",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: General?.isLargeScreen ? "center" : "flex-start",
                        backgroundColor: `${contrast?.contrastColor ? contrast.contrastColor : "#E5EFF2"}`,
                        border: `1px dashed ${contrast?.contrastColor ? contrast.contrastColor : "#B6BFDC"}`,
                        flexDirection: General?.isLargeScreen ? "row" : 'column'
                      }}
                    >
                      <div
                        style={{ display: "flex", gap: "15px", height: "10vh" }}
                      >
                        <div
                          style={{
                            height: "10vh",
                            marginLeft: "20px",
                            marginRight: '20px',
                            width: "2vw",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",

                          }}
                        >
                          <img src={upload} />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <h3
                            style={{
                              margin: 0,
                              fontFamily: "Segoe UI",
                              fontWeight: "700",
                              fontStyle: "normal",
                              fontSize: "16px",
                              lineHeight: "20px",
                              color: contrast?.contrastBackground ? contrast.contrastBackground : General?.ColorAss,
                            }}
                          >
                            {General?.codeLabels["cm_complaint_upload"]?.label ? General?.codeLabels["cm_complaint_upload"]?.label : 'Upload Attachments'}
                          </h3>
                          <p
                            style={{
                              margin: 0,
                              fontFamily: "Segoe UI",
                              fontWeight: "400",
                              fontStyle: "normal",
                              fontSize: "14px",
                              lineHeight: "18px",
                              color: contrast?.contrastBackground ? contrast.contrastBackground : General?.ColorAss,
                            }}
                          >
                            {General?.codeLabels["cm_complaint_min"]?.label ? General?.codeLabels["cm_complaint_min"]?.label : 'Minimum 1 and up to 10'}
                          </p>
                        </div>
                      </div>
                      <div style={{ width: General?.isLargeScreen ? '' : "100%", display: 'flex', justifyContent: "center" }}  >
                        <label
                          style={{
                            color: contrast?.contrastColor
                              ? contrast?.contrastColor
                              : "",
                            border: `1px solid ${contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss}`,
                            padding: General?.isLargeScreen ? "10px" : "15px 100px",
                            fontFamily: "Segoe UI",
                            fontStyle: "normal",
                            fontWeight: "700",
                            fontSize: "16px",
                            lineHeight: "16px",
                            marginRight: General?.isLargeScreen ? "30px" : "",
                            marginLeft: General?.isLargeScreen ? '30px' : "",
                            whiteSpace: 'nowrap',
                            background: `${contrast?.contrastBackground ? contrast?.contrastBackground : "white"}`
                          }}
                          htmlFor="file-upload"
                        >
                          {General?.codeLabels["cm_choosefile"]?.label !==
                            undefined
                            ? General?.codeLabels["cm_choosefile"]?.label
                            : "CHOOSE FILE"}
                        </label>
                        <input

                          id="file-upload"
                          multiple
                          type="file"
                          onChange={(e) => {
                            handleChange(e);
                            handleUploadFileChange(e, setFieldValue); // Pass setFieldValue
                          }}
                          hidden
                        />
                        {values.uploadedFilesData.length > 0 && (
                          <p style={{ color: "green", marginTop: "5px" }}>
                            {values.uploadedFilesData.length} file(s) uploaded
                          </p>
                        )}

                        {errors.uploadedFilesData &&
                          touched.uploadedFilesData && (
                            <div className="error-message">
                              {errors.uploadedFilesData}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>

                  <ReCAPTCHA
                    sitekey={key}
                    onChange={(token) => { handleRecaptchaChange(token) }}
                  />
                  {/* <hr
                    style={{
                      width: "100%",
                      backgroundColor: "#101E8E",
                      mixBlendMode: "normal",
                      opacity: "0.2",
                    }}
                  /> */}
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "0.5rem",
                                    marginBottom: "",
                                  }}
                                >
                                    <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start", // Changed from center to flex-start
                                      gap: "0.5rem",
                                    }}
                                    >
                                    <Field
                                      style={{ 
                                      width: "20px", 
                                      height: "20px",
                                      marginTop: "3px" // Added marginTop to align with text
                                      }}
                                      name="toggle"
                                      type="checkbox"
                                    />
                                    <label
                                      style={{
                                      fontFamily: "Segoe UI",
                                      fontStyle: "normal",
                                      fontWeight: "400",
                                      fontSize: `${General.accessibility.fontSize}rem`,
                                      lineHeight: "20px",
                                      paddingTop:"2px",
                                      color: General.contrast.contrastColor
                                        ? General.contrast.contrastColor
                                        : General?.ColorAss,
                                      }}
                                    >
                                      <span dangerouslySetInnerHTML={{
                                      __html: (General?.codeLabels["cm_user_consent_msg"]?.label !== undefined
                                        ? General?.codeLabels["cm_user_consent_msg"]?.label 
                                          : "I accept all")
                                      }} />
                                    </label>
                                    </div>
                                  <hr style={{ width: "100%" }} />
                                </div>
                  <button
                    style={{
                      backgroundColor: `${contrast?.contrastColor ? contrast.contrastColor : General?.ColorAss}`,
                      width: General?.isLargeScreen ? "15%" : "100%",
                      height: "50px",
                      color: `${contrast?.contrastBackground ? contrast.contrastBackground : "white"}`,
                      justifyContent: "center",
                      fontWeight: "bold",
                      outline: "none",
                      border: "0px",
                      opacity: isRecaptchaVerified && values.toggle ? "1" : "0.5",
                    }}
                    disabled={!isRecaptchaVerified || !values.toggle}
                    type="submit"
                  >
                    {submitLoader ? (
                      <Spinner width="30px" height="30px" />
                    ) : General?.codeLabels["cm_submit"]?.label !==
                      undefined ? (
                      General?.codeLabels["cm_submit"]?.label
                    ) : (
                      "SUBMIT"
                    )}
                  </button>
                </ComplaintForm>
              </ComplaintContainer>
            </Form>
          )}
        </Formik>
      ) : (
        <TabContainer
          style={{
            width: General?.isLargeScreen ? '100%' : "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            alignSelf: "flex-start",
            minHeight: "50vh",
            gap: "0",
            background: contrast?.contrastBackground ? contrast?.contrastBackground : 'white',
            padding:'2.5rem 2.5rem 0rem 2.5rem'
          }}
        >
          <ThankyouHeader>
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M23 0C10.317 0 0 10.317 0 23C0 35.683 10.317 46 23 46C35.683 46 46 35.683 46 23C46 18.44 44.6603 14.1893 42.3633 10.6113L40.9941 12.2285C42.8891 15.3825 44 19.06 44 23C44 34.579 34.579 44 23 44C11.421 44 2 34.579 2 23C2 11.421 11.421 2 23 2C28.443 2 33.3939 4.09977 37.1289 7.50977L38.4375 5.96484C34.3525 2.25984 28.935 0 23 0ZM41.2363 5.75391L21.9141 28.5547L13.7812 20.9688L12.418 22.4316L22.084 31.4473L42.7637 7.04688L41.2363 5.75391Z"
                fill={General?.colorClass ? General?.colorClass : "#62AA51"} />
            </svg>
            <h1 className={General?.textClass}>
              {General?.codeLabels["cm_thankyou"]?.label !== undefined
                ? General?.codeLabels["cm_thankyou"]?.label
                : "Thank you !!!"}
            </h1>
          </ThankyouHeader>
          <ThankyouMessage>
          <h5 className={General?.textClass}>{General?.codeLabels["cm_referenceid"]?.label}  {referenceId}</h5>
            <p className={General?.textClass}>{seccessMsg}</p>

            <ButtonSecondary
              onClick={() => navigate("/dashboard")}
              style={{ background: "#101e8e", color: "#fff" }}
              className={General?.colorClass}
            >
              {General?.codeLabels["cm_back_to_dassh"]?.label ? General?.codeLabels["cm_back_to_dassh"]?.label : 'BACK TO DASHBOARD'}
            </ButtonSecondary>
          </ThankyouMessage>
        </TabContainer>
      )}
    </>
  );
});

export default Complaint;
